import { VerifyAccountPayload, VerifyAccountResponse } from '../../pages/verifyAccount/verifyAccount.model';
import { config } from '../config/config';
import { User } from './';

export default class Auth {
  private url: string = config.armcareServerUrl;
  private urlNewServer = config.armcareNewServerUrl;
  private user = new User();
  public verifyError(response: any) {
    if (response.status === 401) {
      this.LogOut();
    }
  }

  public async GetPaymentStatus(token): Promise<unknown> {
    try {
      const response = await fetch(`${this.url}/api/v2/membership/status`, {
        method: 'GET',
        headers: new Headers({
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        }),
      });
      this.verifyError(response);
      const data = await response.json();
      if (data?.membershipStatus) {
        return { status: true, data };
      } else {
        return { status: false };
      }
    } catch (e) {
      return { status: false };
    }
  }
  public async login(username: string, password: string): Promise<unknown> {
    const body = {
      username,
      password,
      grant_type: 'password',
    };
    try {
      const response = await fetch(`${this.url}/token`, {
        method: 'POST',
        headers: new Headers({
          'Content-Type': 'application/json',
        }),
        body: JSON.stringify(body),
      });
      const data = await response.json();
      if (data?.access_token) {
        if (data.role) {
          const userData: any = await this.user.GetUserData({ data: data });
          if (userData.status) {
            const membership: any = await this.GetPaymentStatus(data?.access_token);
            data.membership = membership?.data;
            data.data = userData.data;

            return { status: true, data };
          } else {
            return { status: false, data };
          }
        } else {
          return { status: false, data };
        }
      } else {
        return { status: false, data };
      }
    } catch (e) {
      return { status: false };
    }
  }

  public async logFromToken(data) {
    if (data?.access_token) {
      const userData: any = await this.user.GetUserData({ data: data });
      if (userData.status) {
        const membership: any = await this.GetPaymentStatus(data?.access_token);
        data.membership = membership?.data;
        data.data = userData.data;
       
        return { status: true, data };
      } else {
        return { status: false, data };
      }
    } else {
      return { status: false, data };
      
    }
   
  }

  public async ChangePassword(currentPassword: string, newPassword: string, confirmNewPassword: string): Promise<unknown> {
    const credentials = this.user.GetUserCredentials() as any;
    const token = credentials.data.access_token;
    const body = JSON.stringify({
      currentPassword,
      newPassword,
      confirmNewPassword,
    });
    const headers = new Headers({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    });
    try {
      const response = await fetch(`${this.url}/api/v1/org-change-password`, {
        method: 'POST',
        headers,
        body,
      });
      this.verifyError(response);
      const data = await response.json();
      if (data?.success) {
        return { status: true, data };
      } else {
        return { status: false };
      }
    } catch (e) {
      return { status: false };
    }
  }
  public async UpdateSettings(
    firstName: string,
    lastName: string,
    name: string,
    email: string,
    orgType2: string,
    city: string,
    state: string,
    phone: string,
    color: string,
    initials: string,
    picture: string = '',
  ): Promise<unknown> {
    const credentials = this.user.GetUserCredentials() as any;
    const token = credentials.data.access_token;
    const body = {
      data: {
        firstName,
        lastName,
        name,
        email,
        orgType2,
        city,
        state,
        phone,
        color,
        initials,
        isFirstLogin: false,
      },
    };
    if (picture) {
      Object.defineProperty(body.data, 'picture', { value: picture, writable: true, configurable: true, enumerable: true });
    }
    const headers = new Headers({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    });
    try {
      const response = await fetch(`${this.url}/api/v2/settings`, {
        method: 'PUT',
        headers,
        body: JSON.stringify(body),
      });
      this.verifyError(response);
      const data = await response.json();
      if (data._id) {
        return { status: true, data };
      } else {
        return { status: false, data };
      }
    } catch (e) {
      return { status: false };
    }
  }
  
  public async UpdatePlayerSettings(
    id: string,
    firstName: string,
    lastName: string,
    email: string,
    picture: string = '',
  ): Promise<unknown> {
    const credentials = this.user.GetUserCredentials() as any;
    const token = credentials.data.access_token;
    const body = {
      data: {
        firstName,
        lastName,
        email,
        picture,
      },
    };

    const headers = new Headers({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    });

    try {
      const response = await fetch(`${this.url}/api/v2/player/${id}`, {
        method: 'PUT',
        headers,
        body: JSON.stringify(body),
      });

      this.verifyError(response);
      const data = await response.json();

      if (data._id) {
        return { status: true, data };
      } else {
        return { status: false, data };
      }
    } catch (e) {
      return { status: false };
    }
  }

public async  updateTimeZone(timezone:string){
  const body = JSON.stringify({
    data: {
      timezone
    }
  })
  const token = this.getTokenAccess();
  const headers = new Headers({
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  })
  try {
    const response = await fetch(`${this.url}/api/v2/settings`, {
      method: "PUT",
      headers,
      body
    })
    const data = await response.json()
     return {status: true, data}
  } catch (error) {
    return {status: false, error}
  }
  
}

  public async RecoverPassword(email: string): Promise<unknown> {
    const body = JSON.stringify({
      data: { email },
    });
    const headers = new Headers({
      'Content-Type': 'application/json',
    });
    try {
      const response = await fetch(`${this.url}/api/v1/forgot-password`, {
        method: 'POST',
        headers,
        body,
      });
      const data = await response.json();

      if (data['forgot-password']) {
        return { status: true, data };
      } else {
        return { status: false };
      }
    } catch (e) {
      return { status: false };
    }
  }

  public async ResetPassword(token: string, password: string): Promise<unknown> {
    const body = JSON.stringify({
      password: password,
      token: token
    });
    const headers = new Headers({
      'Content-Type': 'application/json',
    });

    try {
      const response = await fetch(`${this.url}/api/v1/forgot-password`, {
        method: 'PUT',
        headers,
        body,
      });
      const data = await response.json();

      if (data['result']['message'] === 'Password reset successfully') {
        return { status: true };
      } else {
        return { status: false };
      }
    } catch (e) {
      return { status: false };
    }
  }

  public async LogOut() {
    localStorage.removeItem('team');
    localStorage.removeItem('teams');
    localStorage.removeItem('player');
    localStorage.removeItem('user');
    window.location.reload();
  }

  private getTokenAccess():string {
    const credentials = this.user.GetUserCredentials() as any;
    return credentials.data.access_token
  }

  public async verifyAccount(payload: VerifyAccountPayload): Promise<VerifyAccountResponse> {
    const body = JSON.stringify(payload);
    const headers = new Headers({
      'Content-Type': 'application/json',
    });

    try {
 
      const response = await fetch(`${this.urlNewServer}/v1/subscriptions/verification`, {
        method: 'POST',
        headers,
        body,
      });
      
      const data = await response.json() as VerifyAccountResponse;

      if (data["statusCode"] === 202) {
        return { 
          ...data,
          status: true
        };
      }

      if (!data['error']) {
        return { status: true };
      } else {
        return { status: false, message: data.message };
      }
    } catch (e) {
      return { status: false };
    }
  }
}
